import { setDefaultOptions } from "date-fns";

export const setDateFnsOptions = async () => {
  const currentLocale = window?.locale;

  switch (currentLocale) {
    case "pt": {
      const { ptBR } = await import(
        /* webpackChunkName: "date_fns_pt_br" */ "date-fns/locale/pt-BR"
      );
      setDefaultOptions({ locale: ptBR, weekStartsOn: 1 });
      break;
    }
    case "pt-PT": {
      const { pt } = await import(
        /* webpackChunkName: "date_fns_pt" */ "date-fns/locale/pt"
      );
      setDefaultOptions({ locale: pt, weekStartsOn: 1 });
      break;
    }
    case "es": {
      const { es } = await import(
        /* webpackChunkName: "date_fns_es" */ "date-fns/locale/es"
      );
      setDefaultOptions({ locale: es, weekStartsOn: 1 });
      break;
    }
    case "fr": {
      const { fr } = await import(
        /* webpackChunkName: "date_fns_fr" */ "date-fns/locale/fr"
      );
      setDefaultOptions({ locale: fr, weekStartsOn: 1 });
      break;
    }
    case "it": {
      const { it } = await import(
        /* webpackChunkName: "date_fns_it" */ "date-fns/locale/it"
      );
      setDefaultOptions({ locale: it, weekStartsOn: 1 });
      break;
    }
    case "de": {
      const { de } = await import(
        /* webpackChunkName: "date_fns_de" */ "date-fns/locale/de"
      );
      setDefaultOptions({ locale: de, weekStartsOn: 1 });
      break;
    }
    default: {
      const { enUS } = await import(
        /* webpackChunkName: "date_fns_en_us" */ "date-fns/locale/en-US"
      );
      setDefaultOptions({ locale: enUS });
    }
  }
};
